const emotionCacheProps = {
  key: `xyz`,
  nonce: `XXXYYYZZZ`,
}

export default emotionCacheProps
